module.exports = __webpack_public_path__ + "static/media/factory_top_nova.69a4709d.png";